<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-button class="mr-2" v-b-modal.add-from-stock>Agregar pallets</b-button>
        <b-button class="mr-2" variant="danger" @click.prevent="wipeItems">Limpiar Tabla</b-button>
        <!-- <b-button class="mr-2" v-b-modal.merge-pallet>Unir pallets</b-button> -->

        <b-modal size="xl" id="add-from-stock" title="Stock" @ok="onOk">
          <server-side-table
            ref="table"
            url="/api/v1/stock/"
            :filterable="filterable"
            :headings="headings"
            :column_display="columnsDisplay"
            :columns="columns"
            :marked-rows="markedRows"
            @on-select="onSelect"
          ></server-side-table>
        </b-modal>

        <b-modal size="sm" id="merge-pallet" title="Unir pallets" @ok="handleMerge">
          <b-input v-model="pallet_number"></b-input>
        </b-modal>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          ref="pallet_table"
          small
          striped
          hover
          :fields="fields"
          :items="items"
          :select-mode="selectMode"
          selectable
          @row-selected="onRowSelected"
        >
          <template slot="cell(actions)" slot-scope="item">
            <a href="#" @click.prevent="removeItem(item.item)">
              <i class="fa fa-lg fa-trash text-danger"></i>
            </a>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ServerSideTable from "./ServerSideTable.vue";
export default {
  name: "Step2",
  components: {
    ServerSideTable
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectMode: "multi",
      pallet_number: null,
      selected: [],
      markedRows: [],
      fields: [
        { key: "pallet_number", label: "Número", sorteable: true },
        { key: "product_name", label: "Producto", sorteable: true },
        { key: "product_type_name", label: "Tipo", sorteable: true },
        { key: "variety_name", label: "Variedad", sorteable: true },
        { key: "origin_name", label: "Origen", sorteable: true },
        { key: "condition", label: "Condicion", sorteable: true },
        { key: "container_name", label: "Formato/Recip", sorteable: true },
        { key: "quantity", label: "Cantidad", sorteable: true },
        { key: "net_kilograms", label: "Kg Netos", sorteable: true },
        { key: "actions", label: " ", sorteable: true }
      ],
      columnsDisplay: {
        document: "not_desktop",
        product_name: "not_desktop",
        product_type_name: "min_desktop",
        string_specs: "not_desktop",
        daystay: "min_desktop",
        condition: "not_desktop",
        lot_number: "min_desktop",
        in_process: "not_desktop",
        involved_waybills: "not_desktop",
        last_inspection: "not_desktop",
        position: "not_desktop",
        variety_name: "not_desktop",
        origin_name: "not_desktop"
      },
      columns: [
        "id",
        "pallet_number",
        "lot_number",
        "product_type_name",
        "container_name",
        "daystay",
        "string_specs",
        "variety_name",
        "origin_name",
        "condition",
        "in_process",
        "last_inspection",
        "quantity",
        "net_kilograms",
        "actions"
      ],
      filterable: [
        "client_customer_name",
        "pallet_number",
        "lot_number",
        "product_type_name",
        "product_name",
        "container_name",
        "position"
      ],
      headings: {
        pallet_number: "Pallet",
        lot_number: "Lote",
        container_name: "Formato/Recipiente",
        quantity: "Cantidad",
        product_type_name: "Tipo Producto",
        net_kilograms: "KN",
        daystay: "Días estadía",
        string_specs: "Especificaciones",
        last_inspection: "Inspección",
        in_process: "En proceso",
        variety_name: "Variedad",
        origin_name: "Huerto"
      }
    };
  },
  methods: {
    removeItem(item) {
      this.items = this.items.filter((i) => i.id !== item.id);
      this.markedRows = this.markedRows.filter((i) => i.id !== item.id);
    },
    onSelect(item) {
      this.markedRows.push(item);
    },
    wipeItems() {
      this.items = [];
      this.markedRows = [];
    },
    onOk() {
      this.items = this.markedRows.filter((item) => item.checked);
      this.$emit(
        "update:items",
        this.markedRows.filter((item) => item.checked)
      );
    },
    onRowSelected(items) {
      this.selected = items;
    },
    handleMerge() {
      this.selected.forEach((item) => {
        item.pallet_number = this.pallet_number;
        item.merged = true;
      });

      this.$refs.pallet_table.clearSelected();
      this.selected = [];
      this.pallet_number = null;
    }
  }
};
</script>

<style></style>
